
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ahfQJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bbc00626bf65280e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $bbc00626bf65280e$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "\u7121\u6A19\u984C\u9801\u9762",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "\u5EFA\u7ACB\u65B0\u9801\u9762\u4E26\u4EE5\u9023\u7D50\u63D2\u5165",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "\u5EFA\u7ACB Confluence \u9801\u9762",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "\u5728 Confluence \u4E2D\u958B\u555F",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "\u60A8\u7684\u9801\u9762\u5DF2\u5EFA\u7ACB",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "\u5DF2\u5EFA\u7ACB\u9801\u9762",
    'editorExtensionLinkCreate.confluencePage.title': "\u5EFA\u7ACB\u65B0\u9801\u9762",
    'editorExtensionLinkCreate.genericError.description': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'editorExtensionLinkCreate.genericError.title': "\u767C\u751F\u932F\u8AA4",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "\u5EFA\u7ACB\u5167\u5D4C\u8B70\u984C\uFF0C\u4E26\u4EE5\u9023\u7D50\u63D2\u5165",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': "\u5EFA\u7ACB Jira \u8B70\u984C",
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "\u5728 Jira \u4E2D\u958B\u555F",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "\u60A8\u7684\u8B70\u984C\u5DF2\u5EFA\u7ACB",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': "\u5DF2\u5EFA\u7ACB\u8B70\u984C",
    'editorExtensionLinkCreate.jiraIssue.title': "\u5EFA\u7ACB\u65B0\u8B70\u984C",
    'editorExtensionLinkCreate.keyword.create': "\u5EFA\u7ACB",
    'editorExtensionLinkCreate.keyword.issue': "\u8B70\u984C",
    'editorExtensionLinkCreate.keyword.new': "\u65B0",
    'editorExtensionLinkCreate.keyword.page': "\u9801\u9762",
    'editorExtensionLinkCreate.keyword.publish': "\u767C\u4F48",
    'editorExtensionLinkCreate.keyword.raise': "\u63D0\u51FA",
    'editorExtensionLinkCreate.keyword.space': "\u7A7A\u9593",
    'editorExtensionLinkCreate.keyword.ticket': "\u5DE5\u55AE"
};

});


//# sourceMappingURL=zh_TW.36f99807.js.map
